<template>
	<div style="padding: 20px;">
		<DescriptionList title="" :col="4" :data="basicInfo">
			<!-- 使用作用域插槽自定义复杂内容 -->
			<template #status="{ record }">
				<Tag :type="record.value === '激活' ? 'success' : 'default'">
					{{ record.value }}
				</Tag>
			</template>
		</DescriptionList>
	</div>
</template>

<script>
	import DescriptionList from './DescriptionList.vue'; // 假设路径

	export default {
		components: {
			DescriptionList
		},
		props: {
			row: {
				type: Object,
				default: () => {}
			},
		},
		data() {
			return {
				basicInfo: [{
						label: 'ID',
						key: 'Id',
						value: this.row.Id
					},
					{
						label: this.$tt('设备序列号'),
						key: 'EquipSerialNo',
						value: this.row.EquipSerialNo,
					},
					{
						label: this.$tt('模块地址'),
						key: 'ModuleAddr',
						value: this.row.ModuleAddr,
					}, // 自定义占位
					{
						label: this.$tt('所属分组'),
						key: 'ModuleGroup',
						value: this.row.ModuleGroup
					},
					{
						label: this.$tt('组内模块数量'),
						key: 'ModuleNumInGroup',
						value: this.row.ModuleNumInGroup
					},
					{
						label: this.$tt('分配终端号'),
						key: 'SwitchTo',
						value: this.row.SwitchTo
					},

					{
						label: this.$tt('模块类型'),
						key: 'ModuleType',
						value: this.row.ModuleType
					},
					{
						label: this.$tt('模块状态'),
						key: 'ModuleStatus',
						value: this.row.ModuleStatus === 0 ? '关机' : '开机',
						render: (h, params) => {
							const val = params.row.ModuleStatus;
							return h('Tag', {
								props: {
									color: val === 1 ? 'success' : 'default'
								}
							}, val === 1 ? '开机' : '关机');
						}
					},
					{
						label: this.$tt('故障码'),
						key: 'FaultCode',
						value: this.row.FaultCode,
						
					},
					{
						label: this.$tt('设置电压(V)'),
						key: 'SetVoltage',
						value: this.row.SetVoltage
					},
					{
						label: this.$tt('设置电流(A)'),
						key: 'SetCurrent',
						value: this.row.SetCurrent
					},

					{
						label: this.$tt('输出电压(V)'),
						key: 'OutputVoltage',
						value: this.row.OutputVoltage
					},
					{
						label: this.$tt('输出电流(A)'),
						key: 'OutputCurrent',
						value: this.row.OutputCurrent
					},
					{
						label: this.$tt('模块温度(℃)'),
						key: 'ModuleTemp',
						value: this.row.ModuleTemp
					},
					{
						label: this.$tt('上报时间'),
						key: 'ReportTime',
						value: this.row.ReportTime
					},
				]
			};
		}
	};
</script>
